module.exports = __webpack_public_path__ + "static/media/18x24no3.ec94a70a.jpg";